// src/components/reports/ImageCell.jsx

import React from 'react';
import { getDriveThumbnailUrl, getGoogleDriveViewUrl } from '../../utils/driveUtils';
import { PAGE } from '../ui';
import { REPORT_COLORS } from './theme';

export default function ImageCell({ url }) {
  const thumbnailUrl = getDriveThumbnailUrl(url);
  const viewUrl = getGoogleDriveViewUrl(url);

  if (!url) {
    return (
      <span style={{ color: PAGE.colors.muted, fontSize: 13, fontWeight: 700 }}>
        —
      </span>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 118 }}>
      <a href={viewUrl} target="_blank" rel="noreferrer">
        <img
          src={thumbnailUrl}
          alt="Unloading"
          style={{
            width: 56,
            height: 40,
            objectFit: 'cover',
            borderRadius: 10,
            border: `1px solid ${REPORT_COLORS.line}`,
            background: REPORT_COLORS.bg,
            display: 'block',
          }}
          onError={e => {
            e.currentTarget.style.display = 'none';
          }}
        />
      </a>

      <a
        href={viewUrl}
        target="_blank"
        rel="noreferrer"
        style={{
          fontSize: 12,
          fontWeight: 900,
          color: REPORT_COLORS.blue,
          textDecoration: 'none',
          padding: '6px 10px',
          borderRadius: 999,
          background: REPORT_COLORS.blueSoft,
          whiteSpace: 'nowrap',
        }}
      >
        Open
      </a>
    </div>
  );
}
